if (BUILD_TARGET === 'app-node-pl') {
  window.Drupal = {
    t(string, replacements) {
      if (replacements) {
        console.log(
          'Not replacing placeholders because this is a stub.',
          replacements
        );
      }
      return string;
    },
  };
}

export default {
  methods: {
    t(string, replacements) {
      return window.Drupal.t(string, replacements);
    },
  },
};
